export const situationsThree = [
  {
    id: 1,
    text: "You thrashed two of your college boys but later you patched up and became good friends. One day three of you went boating in a big lake. Once your boat reached the center of the lake, your friend pounced on you to avenge the earlier fight. You...",
    response: "Defended and overpowered them and later broke friendship.",
  },
  {
    id: 2,
    text: "On walking on a lonely road from railway station to home, a person snatches the gold chain of your mother and sprinkle the chilly powder over your face and start to run. You...",
    response:
      "Washed my face, went to the police, gave all the details and got a sketch made of the thief.",
  },
  {
    id: 3,
    text: "His neighbor came and complained that certain anti-social elements of the locality were harassing him under instructions from his landlord who was forcing him to vacate the house. So he...",
    response:
      " He told them to lodge a complaint against the landlord and also helped them to find the new rented house.",
  },
  {
    id: 4,
    text: "Ram was traveling a train compartment in which there were five students also. When the TTE asked them to show their tickets, they refused. They threatened him with dire consequences if he tried to be strict with them. So he...",
    response:
      "He confronted them with co-passengers help and compelled them to show ticket and if not found, made them give fine.",
  },
  {
    id: 5,
    text: "His final exam was to be held after one month. Some of his friends asked him to lead a delegation to the Principal to request for the postponement of the exam for two months. So he...",
    response:
      "He refused and suggested them to study and provide assistance if needed. ",
  },
  {
    id: 6,
    text: "You mixed with a certain type of people only because...",
    response:
      "They are like-mined and help in exploring new thought processes.",
  },
  {
    id: 7,
    text: "You think illiteracy from our country can be removed by...",
    response:
      "Increasing standards of government schools and implementing in true spirit the compulsory education program till 14 years of age.",
  },
  {
    id: 8,
    text: "In a discussion, you often win an argument because you...",
    response:
      "Listen to other's points of view carefully and present logical points to tackle them.",
  },
  {
    id: 9,
    text: "Ram is an MBA. He wants to be a manager in a big company. He was called for interview four times but not selected. His uncle wants him to join grocery shop. So he...",
    response:
      " He joined the shop and kept preparing for the interview alongside, worked on his shortcomings and got selected in next attempt.",
  },
  {
    id: 10,
    text: "He was the captain of his school's/college's hockey team. The team was playing a match. Because of the partial umpiring on two occasions, two of his players walked out of the playground and refused to play. So he...",
    response:
      " He raised the matter and convinced authority to change the umpire and continued playing the match.",
  },
  {
    id: 11,
    text: "She is alone at home with her younger brother. Other members of her family have gone to attend a marriage. One of her old friends turned up. She asked her younger brother to get some sweets from the market. The brother refused saying that he was to go to play cricket. So she...",
    response: "Lured brother to bring sweet by promising him for a treat.",
  },
  {
    id: 12,
    text: "One day She had a bitter argument with her brother who is one year younger to her and studying in class 11th. The brother stopped talking to her. So She...",
    response:
      "She gave time and space to her brother, talked to him and re-established healthy relationship.",
  },
  {
    id: 13,
    text: "He was reading in the school's library at 7 pm and there were only a few students there at that time. Suddenly he saw smoke coming out from the Principal’s office and the office was locked. So he...",
    response:
      "He immediately informed librarian and directed the guard to unlock the room and extinguish the fire with the help of fire extinguisher. ",
  },
  {
    id: 14,
    text: "He has been given a good thrashing in the college compound. He...",
    response:
      "He complained to the principal and got action initiated against them.",
  },
  {
    id: 15,
    text: "One of his subordinates shirks responsibility and shows insubordination. He...",
    response: "He took disciplinary action against him and suspended him.",
  },
  {
    id: 16,
    text: "After the train journey, he discovers that his briefcase has been exchanged with some fellow traveler. The briefcase in his possession now contains valuables and gold. He...",
    response: "Tracked the traveler and exchanged the briefcase.",
  },
  {
    id: 17,
    text: "He is an excellent hockey player and had represented his school team. However, in the college he is not selected because of obvious favoritism. So he...",
    response: "Joined a local club and prepared for the Nationals.",
  },
  {
    id: 18,
    text: "He was returning home after a late-night show on cycle when a speeding jeep hit him from behind. He...",
    response:
      "He took help from passerby, got hospitalized and later lodge a complaint against the car driver.",
  },
  {
    id: 19,
    text: "When half of the preparation for his sister's wedding was through, the groom's family canceled the wedding. He will...",
    response:
      "He asked the reason and if found unjustifiable, lodge complaint against them. ",
  },
  {
    id: 20,
    text: "His friends were fond of swimming in the pond and he did not know how to swim at all. One evening they insisted on his jumping into the pond and promised to help him out in case of trouble. So he jumped and landed in the deep water. He would....",
    response: "He thrust himself on the surface and shouted for help. ",
  },
  {
    id: 21,
    text: "When he was going to face the SSB, he has taken a cup of tea at Railway Station. At the time of paying the money he found his pocket missing. He...",
    response: " He made online payment and lodge a complaint to RPF.",
  },
  {
    id: 22,
    text: "He was all set to go on a vacation with the family when an important business work came up. He...",
    response:
      "He completed all formality beforehand and delegated work of attending the meeting to manager. ",
  },
  {
    id: 23,
    text: "If you have an alternative carrier in view, what is your plan to attain it...",
    response: "Prepare for Civil services, Join IPS and serve the nation.",
  },
  {
    id: 24,
    text: "What is your opinion, should be done to make democracy a success...",
    response:
      "Reduction in Red tapism and fixing accountability by making official work transparent.",
  },
  {
    id: 25,
    text: "When you think of a difficult task ahead of you, you would...",
    response:
      "Remain calm and think about the possibility along with the consequence of step to be taken.",
  },
  {
    id: 26,
    text: "In what field our country can make remarkable progress and why...",
    response:
      "In the manufacturing of medicine as India is the second-largest manufacturer of medicines.",
  },
  {
    id: 27,
    text: "How should the government solve the economic problem of the country...",
    response:
      "Promoting the establishment of private companies, keeping a check on black money, making bureaucracy more transparent.",
  },
  {
    id: 28,
    text: "Have you ever felt interested in writing something for the school or the college magazine? If so on what subject...",
    response: "A detailed article on the heroes of Indian Armed Forces.",
  },
  {
    id: 29,
    text: " If you find that a particular work is taking more time than you expressed in the beginning, you will...",
    response: "Completes the work efficiently irrespective of time.",
  },
  {
    id: 30,
    text: "You become the secretary of the college union, while the president is a girl of the opposite group. You will...",
    response:
      "Respected her authority and worked impartially for the welfare of the students.",
  },
  {
    id: 31,
    text: "While on a picnic your friends refused to take part in music competition being conducted. You would...",
    response: "Cheered him along with friends and convinced him to sing.",
  },
  {
    id: 32,
    text: "Your best friend joined the company of your opponents and they are putting him against you in college election. You...",
    response: "Talked to my friend and convinced him to join my party.",
  },
  {
    id: 33,
    text: "Many of your friends are on hunger strike for a political cause but your father warns you not to join the hunger strike. You will...",
    response: "Respected father’s concern and supported friends morally.",
  },
  {
    id: 34,
    text: "Your favorite game is basketball but there is no basketball court in your school. You...",
    response:
      "Wrote application to sports teacher and principal and showed inclination of maximum students in basketball and convinced them to construct a basketball court.",
  },
  {
    id: 35,
    text: "Your mathematics teacher is retiring next month but he was not your favorite teacher and also you had some conflict with him in the past. Your classmates decide to collect money for his tea party. You will...",
    response:
      "Gave money and wished him for his new phase of life happily farewelled him.",
  },
  {
    id: 36,
    text: "In your office, your senior gives you a task about which you were not briefed at all earlier. There is no time to find out the details. What would you do...",
    response:
      "Took help from colleagues and completed the task efficiently within time.",
  },
  {
    id: 37,
    text: "Your boss is ordering you to do something which you feel is morally incorrect but he threats you that if you do not do it he will remove you from the job. You are a very poor person, who has to support a younger brother and sister and an ailing mother. You will...",
    response:
      "Wrote an email to the president of the company about his boss and got the action initiated against him.",
  },
  {
    id: 38,
    text: "There are only 20 minutes left for the exam to get over and you have not attempted six remaining questions yet. You will...",
    response: "Remained calm and attempted high marks question first.",
  },
  {
    id: 39,
    text: "Your parents are out for a week. All of a sudden your younger brother decided to do court marriage against the wish of his parents. You will...",
    response:
      "Talked to brother, stopped the marriage and assured him to help in talking with parents. ",
  },
  {
    id: 40,
    text: "He came to know that his newly married wife is barren and can't have children. He...",
    response: "He convinced his wife for adoption.",
  },
  {
    id: 41,
    text: "He was studying late in the night and at 2 am he finds a man’s shadow entering neighbor’s house through the ventilator. He...",
    response:
      " He shouted and alerted security & neighbors and got him caught and handed over to police.",
  },
  {
    id: 42,
    text: "Fire broke in the village due to short-circuiting of electricity at night. He is the only electrician in the village. He will... ",
    response:
      "He immediately rushed to the main point, turned off the power supply, called the fire brigade and ambulance and helped in the evacuation of people.",
  },
  {
    id: 43,
    text: "While studying he is giving tuition side by side. But his parents and friends are advising him to leave the tuition as he is not getting sufficient time for examinations. His financial condition is quite weak. He will...",
    response:
      "He assured them about his good preparation for the exam and continued giving tuition and scored well in the exam.",
  },
  {
    id: 44,
    text: "He is about to take bath in the bathroom and has removed his clothes, put on the hook in the distant corner (6feet away) and suddenly one black cobra comes through the drain and stands in front of him. He will...",
    response:
      "He immediately put an empty bucket over cobra and covered him, wear clothes and informed parents and act accordingly.",
  },
  {
    id: 45,
    text: " In the cinema hall, where he is seeing the picture in the last row, some bad elements are teasing a girl in the front row. He will...",
    response:
      " He confronted them with audience help and encouraged the girl to lodge a complaint. ",
  },
  {
    id: 46,
    text: "Two young persons at midnight enter his house at gunpoint and need shelter for the night. Their clothes are having bloodstains, appear to have been involved in the murder. He will...",
    response:
      "He allowed them and in mid-night covertly informed the police and got them arrested.",
  },
  {
    id: 47,
    text: "Your maid had invited you to her daughter's wedding. You would...",
    response:
      "Went with sweets and gift and gave the blessing and wishes to the newlyweds.",
  },
  {
    id: 48,
    text: "You are alone in the house and your sister-in-law is suddenly experiencing labor pains. You would...",
    response:
      "Immediately admitted her in hospital and informed family members.",
  },
  {
    id: 49,
    text: "While traveling in your car, a certain person stops you on the way asking you to take an injured child to the hospital. You would...",
    response:
      "Took the child to a nearby hospital and provided possible assistance. ",
  },
  {
    id: 50,
    text: "While passing through a railway line, you notice that two trains from the opposite direction are running on the same line. You would...",
    response:
      "Informed railway authority and showed red flag and stopped the train.",
  },
  {
    id: 51,
    text: "Your stepmother is very rude to your younger sister. You will...",
    response:
      "Told father about it and sent younger sister to grandparents home.",
  },
  {
    id: 52,
    text: "You have just 24 hours to live. What will you do...",
    response: "Will spend maximum time with family.",
  },
  {
    id: 53,
    text: "A girl/boy from your class is forcing you to have physical relation with her/him. You will...",
    response: "Denied and informed to the parents and college authority.",
  },
  {
    id: 54,
    text: "You are against dowry but your father wants to take dowry on your marriage. You will...",
    response:
      "Talked to father, told him about its illegality and immorality and convinced him.",
  },
  {
    id: 55,
    text: "Which personality dead or alive you hate the most and why...",
    response:
      "Alive: Mehbooba Mufti for her utter hate against the country; Dead: Yakub Menon as he was a terrorist and was part of Mumbai attack.",
  },
  {
    id: 56,
    text: "Which is your favorite vacation destination and why...",
    response: "Mussorie as it rejuvenates the soul.",
  },
  {
    id: 57,
    text: "You are often irritated by the loudspeaker being played in your locality. What will you do...",
    response:
      "Gathered others support and Complained to police about the unreasonable playing of the loudspeaker.",
  },
  {
    id: 58,
    text: "Your damaged product is in warranty but service center refuses to repair it. You will...",
    response:
      "Talked to the manager and if not agree lodge consumer complaint.",
  },
  {
    id: 59,
    text: "You feel that cases of rapes can be reduced if...",
    response:
      "Awareness related to sexual offenses and right of the victim to be taught in schools.",
  },
  {
    id: 60,
    text: "You are the richest man on this planet. What will you do...",
    response:
      "Open high standard school for poor children and canteens for distribution of free food",
  },
  {
    id: 60,
    text: "You are the richest man on this planet. What will you do...",
    response:
      "Open high standard school for poor children and canteens for distribution of free food",
  },
];
